import { Component } from 'react';
import PropTypes from 'prop-types';

const DOT_MARKER_ICON =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48Y2lyY2xlIGZpbGwtb3BhY2l0eT0iLjE1IiBmaWxsPSIjMkUyRUU1IiBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiLz48Y2lyY2xlIGZpbGw9IiNFNTQ1NjMiIGN4PSI0MCIgY3k9IjQwIiByPSIxMCIvPjwvZz48L3N2Zz4=';
const POINTER_MARKER_ICON =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIzMyI+PHBhdGggZmlsbD0iI0U1NDU2MyIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTEzIDFjNi42MjcgMCAxMiA1LjUyMiAxMiAxMi4zMzNDMjUgMjIuNTg1IDEzIDMxIDEzIDMxUzEgMjIuNTg1IDEgMTMuMzMzQzEgNi41MjIgNi4zNzMgMSAxMyAxem00LjUgMTJhNC41IDQuNSAwIDEgMC05LS4wMDEgNC41IDQuNSAwIDAgMCA5IDB6Ii8+PC9zdmc+';

const MOUSE_LENIENCY_TIME = 300;

let GoogleMapPopup;
function defineGoogleMapPopupIfNeeded() {
  if (!GoogleMapPopup) {
    // eslint-disable-next-line global-require
    GoogleMapPopup = require('./GoogleMapPopup.js').default;
  }
}
export default class GoogleMapMarker extends Component {
  static propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    map: PropTypes.object,
    markerType: PropTypes.oneOf(['dot', 'pointer']),
    onClick: PropTypes.func,
    popup: PropTypes.shape({
      image: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      title: PropTypes.string.isRequired
    }),
    title: PropTypes.string,
    icon: PropTypes.shape({
      anchor: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }),
      url: PropTypes.string
    })
  };

  static defaultProps = {
    map: null,
    onClick: null,
    popup: null,
    markerType: 'dot',
    title: '',
    icon: null
  };

  isMouseIn = false;
  isPopupVisible = false;
  mouseInTimeoutId = null;

  initMarker() {
    const { lat, lng, map, markerType, onClick, popup, title, icon } =
      this.props;

    const position = new window.google.maps.LatLng(lat, lng);

    this.marker = new window.google.maps.Marker({
      icon: {
        anchor:
          markerType === 'pointer'
            ? new window.google.maps.Point(12, 16.5) // pointer is 24x33
            : new window.google.maps.Point(40, 40), // dot is 80x80
        url: markerType === 'pointer' ? POINTER_MARKER_ICON : DOT_MARKER_ICON,
        ...icon
      },
      position,
      title
    });

    if (popup) {
      defineGoogleMapPopupIfNeeded();
      this.popup = new GoogleMapPopup({
        ...popup,
        position,
        map,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onClick
      });
      this.marker.addListener('mouseover', this.handleMouseOver);
      this.marker.addListener('mouseout', this.handleMouseOut);
    }

    if (onClick) {
      this.marker.addListener('click', this.handleClick);
    }

    this.marker.setMap(map);
  }

  destroyMarker() {
    this.marker.setMap(null);
  }

  showPopup() {
    this.isPopupVisible = false;
    this.popup.show();
  }

  // google event
  handleMouseOver = () => {
    this.isMouseIn = true;
    this.popup.show();
  };

  // google event
  handleMouseOut = () => {
    this.isMouseIn = false;

    window.setTimeout(() => {
      if (!this.isMouseIn) {
        this.popup.hide();
      }
    }, MOUSE_LENIENCY_TIME);
  };

  // google event
  handleClick = e => this.props.onClick(e.domEvent);

  componentDidMount() {
    this.initMarker();
  }

  componentWillUnmount() {
    this.destroyMarker();
  }

  render() {
    // don't explicitly render anything; just need to trigger lifecycle methods
    return null;
  }
}
